// src/pages/InfoPage.jsx
import React from "react";
import InfoAccordion from "../components/info/InfoAccordion";
import { useTranslation } from "react-i18next";

export default function InfoPage() {
  const { t } = useTranslation();

  // Choose which blocks to show (order is up to you)
  const infoKeys = [
    "info.bestRecording",
    "info.noResultHelp",
    // "info.lungAge",
    "info.lungFitnessScore",
    "info.respiratoryRate",
    "info.breathingRecovery",
    "info.recoveryTime",
    "info.recoveryCurve",
    "info.breathingTrace",
  ];

  return (
    <div className="relative w-full max-w-lg h-fit flex flex-col p-4 gap-4 z-10 mx-auto">
      <h1 className="title-text">
        {t("info.title", {
          defaultValue: "Learn about what makes up BreatheUltra",
        })}
      </h1>
      <p className="">
        {t("info.tapDesc", {
          defaultValue: "Tap a title to view more details.",
        })}
      </p>
      <InfoAccordion
        infoKeys={infoKeys}
        allowMultiple={true}
        deepLinking={true}
      />
    </div>
  );
}
